import { TravelRouteService } from "../services/travel-route.service";
import { Order } from "../models/order";
import { TravelExpense } from "../models/travel-expense";
import { TravelRoute } from "../models/travel-route";
import { Set } from "../models/set";
import { TravelLine } from "../models/travel-line";
import { Injectable } from "@angular/core";
import { Unity } from "../models/unity";

@Injectable({
  providedIn: 'root',
})
export class TravelManager {
  constructor(private routeServ:TravelRouteService) {}

  getRoutesByAddresses(source_customer_address_id:number, target_customer_address_id:number, callback:(routes:TravelRoute[]) => void) {
    this.routeServ.getByAddresses(source_customer_address_id, target_customer_address_id).then(routes => {

      callback(routes);

    });
  }

  getExpenses(route:TravelRoute, truck:Unity, trailer_1?:Unity, trailer_2?:Unity, trailer_3?:Unity) : TravelExpense[] {
    let travelExpenses:TravelExpense[] = [];
    let axis = this.getAxis(truck, trailer_1, trailer_2, trailer_3);

    for (let j = 0; j < route.expenses.length; j++) {
      let price:number = 0;
      let expense = route.expenses[j];

      if (expense.expense_type_id == 1) {
        //calcular total de acuerdo a ejes
        for(let i = 0; i < expense.axis.length; i++) {
          if (expense.axis[i].axis == axis) {
            price = expense.axis[i].price;
            break;
          }
        }
      } else {
        price = expense.price;
      }

      travelExpenses.push({
        axis: axis,
        travel_id: 0,
        expense_id: expense.id,
        expense_name: expense.name,
        price: price,//calcular este
        quantity: 1,
        travel_line_id: 0,
        active: true,
        first: true,
        expense_type: expense.expense_type.type,
        expense_type_name: expense.expense_type.name,
        expense_type_id: expense.expense_type.id,
        automatic: true,
      });
    }

    return travelExpenses;

  }

  getAxis(truck:Unity, trailer_1?:Unity, trailer_2?:Unity, trailer_3?:Unity) : number {
    let total:number = 0;

    total += truck.num_rims;
    total += trailer_1 ? trailer_1.num_rims : 0;
    total += trailer_2 ? trailer_1.num_rims : 0;
    total += trailer_3 ? trailer_1.num_rims : 0;

    return total;
  }
}
